import React from "react";

/**
 * Skeleton loading placeholder. Shimmers subtly. Use `lines=N` for stacked
 * rows or pass explicit width/height for a single block.
 */
export default function LoadingSkeleton({
  lines = 1, height = 14, width = "100%", gap = 8,
  variant = "line", testId,
}) {
  const items = Array.from({ length: lines });
  const style = variant === "circle"
    ? { width: height, height, borderRadius: "50%" }
    : { width, height, borderRadius: 6 };
  return (
    <div
      className="hbf-skel-group"
      style={{ display: "flex", flexDirection: "column", gap }}
      data-testid={testId || "skeleton"}
      aria-busy="true"
    >
      {items.map((_, i) => (
        <div key={i} className="hbf-skel" style={style} />
      ))}
    </div>
  );
}
